import React, { useState, useEffect } from "react";
import {
  BackArrowButton,
  CancelButton,
  ContinueButton,
  CloseButton,
} from "../../../fixedassetelements/button/Button";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./ColumnMapping.module.css";
import commonstyles from "../Forms.module.css";
import swal from "sweetalert";
import {
  getSaleMapping,
  updateSaleMapping,
} from "../../../../Bookclosure/Services/ApiHandler";

const LABEL_FIELDS = [
  "Document Type",
  "Invoice Number",
  "Sell To Customer Code",   
  "Sell To Customer Name",
  "Bill To Customer Code",   
  "Bill To Customer Name",
  "Order Reference",
  "Sales Representative",
  "Currency",
  "Invoice Date",
  "Payment Terms",
  "Due Date",
  "Gross Amount",
  "GST",
  "Total Invoice",
  "Discounts & Others",
];

const KEY_FIELDS = [
  "documentType",
  "invoiceNumber",
  "sellToCustomerCode",  
  "sellToCustomerName",
  "billToCustomerCode",  
  "billToCustomerName",
  "orderReference",
  "salesRepresentative",
  "currency",
  "invoiceDate",
  "paymentTerms",
  "dueDate",
  "grossAmount",
  "GST",
  "totalInvoice",
  "discountsAndOthers"
];

const LABEL_TO_KEY = LABEL_FIELDS.reduce((acc, label, index) => {
  acc[label] = KEY_FIELDS[index];
  return acc;
}, {});

const DEFAULT_MAPPING = {
  documentType: "Document Type",
  invoiceNumber: "Invoice Number",
  sellToCustomerCode: "Sell To Customer Code",  
  sellToCustomerName: "Sell To Customer Name",
  billToCustomerCode: "Bill To Customer Code",  
  billToCustomerName: "Bill To Customer Name",
  orderReference: "Order Reference",
  salesRepresentative: "Sales Representative",
  currency: "Currency",
  invoiceDate: "Invoice Date",
  paymentTerms: "Payment Terms",
  dueDate: "Due Date",
  grossAmount: "Gross Amount",
  GST: "GST",
  totalInvoice: "Total Invoice",
  discountsAndOthers: "Discounts & Others",
};

const ColumnMapping = ({ SaleID, onContinue, onBack, onCancel, onClose }) => {
  const [columnOptions, setColumnOptions] = useState([]);

  const [mappedValues, setMappedValues] = useState(
    KEY_FIELDS.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
  );

  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    const fetchMapping = async () => {
      setLoading(true);
      setApiError(null);

      try {
        const response = await getSaleMapping(SaleID);
        const fields = response?.data?.fields || [];

        setColumnOptions(fields);

        const autoMapped = {};
        KEY_FIELDS.forEach((key) => {
          const defaultValue = DEFAULT_MAPPING[key];
          if (fields.includes(defaultValue)) {
            autoMapped[key] = defaultValue;
          }
        });

        setMappedValues((prev) => ({ ...prev, ...autoMapped }));
      } catch (error) {
        console.error("Error fetching sale mapping:", error);
        setApiError("Failed to load");
      }

      setLoading(false);
    };

    fetchMapping();
  }, [SaleID]);

  const handleFieldChange = (label, value) => {
    const key = LABEL_TO_KEY[label];
    setMappedValues((prev) => ({ ...prev, [key]: value }));
  };

  const fieldsMapped = KEY_FIELDS.every(
    (key) => mappedValues[key] && mappedValues[key] !== ""
  );


const handleSubmit = async () => {

  if (!fieldsMapped) {
    swal("Error ", "Please fill all required fields.", "error");
    return;
  }

  try {
    setLoading(true);

    await updateSaleMapping(SaleID, mappedValues);

    onContinue();
  } catch (error) {
    console.error("Error updating sale mapping:", error);


    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.detail ||
      error?.message ||
      "Something went wrong.";

    swal("Error ❌", errorMessage, "error");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.largeContainer}`}
      >
        <header
          className={commonstyles.header}
        >
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>Map Column Headers</h2>
          </div>
          <CloseButton onClick={onClose} />
        </header>

     <div className={commonstyles.content} style={{ 
        flex: 1, 
        overflowY: 'auto',  
      }}>
          <form className={styles.gridForm}>
            {LABEL_FIELDS.map((label) => (
              <CustomDropdown
                key={label}
                label={label}
                required
                value={mappedValues[LABEL_TO_KEY[label]] || ""}
                onChange={(value) => handleFieldChange(label, value)}
                options={columnOptions}
                placeholder="Select Column"
              />
            ))}
          </form>
</div>
          <div className={commonstyles.footer}>
            <CancelButton onClick={onCancel} />

            <ContinueButton
              onClick={handleSubmit}
              disabled={!fieldsMapped || loading || apiError}
            />
          </div>
        </div>
      </div>
  
  );
};

export default ColumnMapping;
